module.exports = __webpack_public_path__ + "static/media/product_640-4.2110d8cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/product_640-4.jpg
// module id = 2387
// module chunks = 0